var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXportal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3 7h26C90 7 95.7 12 95.7 21c0 9-5.8 14.3-16.6 14.3h-18v18.8h-7.9V7Zm8 7.1v14.1h17.8c5.7 0 8.5-2.7 8.5-7s-2.7-7-8.5-7H61.3ZM144.5 33c0 12.5-9.8 22-22.4 22a21.8 21.8 0 0 1-22.4-22c0-12.6 9.6-22.2 22.4-22.2 12.7 0 22.4 9.6 22.4 22.1Zm-8.1 0c0-8.5-5.8-15-14.3-15s-14.3 6.7-14.3 15c0 8.2 5.7 14.8 14.3 14.8 8.5 0 14.3-6.4 14.3-14.9ZM241.8 27.6h14.4c0-6.4-5-10-11.9-10s-9.8 4-10.4 5.3H226c1.1-5 6.7-12 18.3-12 12.3 0 19.3 6.9 19.3 16.7V43c0 3 1 4.1 3.7 4.4v7c-6-.2-9.7-2.4-10.8-6.6-2 3.2-6.5 7.1-14 7.1-10 0-17.7-5.5-17.7-14.2s6.4-13.2 17-13.2Zm14.4 10.5v-4.3h-14c-5.9 0-9.6 2.3-9.6 7s4.6 7.7 10.6 7.7c6.8 0 13-3.3 13-10.4ZM274.3 0h7.7v54.2h-7.7V0ZM219.4 54.2h-10c-9.7 0-14.6-4.7-14.6-14v-21h-12.5v-7h12.5V2.3h7.7v10h17v6.9h-17v19.2c0 6.1 2 8.7 8.7 8.7h8.2v7.1ZM159.2 54.2h-7.8V12h7.8v7.6c1.2-3 4.8-8 14.7-8h4.6v7.7h-4.8c-10.8 0-14.5 3.6-14.5 11v24Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.1 18.6 18.6-9.7-3.1-5.8-17 6.7c-.5.2-1 .2-1.4 0L3.2 3 0 8.9l18.6 9.7L0 28.2l3.1 5.9 17-6.7c.5-.2 1-.2 1.4 0l17 6.7 3.2-5.9-18.6-9.6Z",
    fill: "#23F7DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXportal);
export default __webpack_public_path__ + "static/media/xportal.40b5d9d3dda97a6b632277f7b3d41a10.svg";
export { ForwardRef as ReactComponent };